import { render, staticRenderFns } from "./SellingProduct.vue?vue&type=template&id=48283146&"
import script from "./SellingProduct.vue?vue&type=script&lang=js&"
export * from "./SellingProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports